export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  character: string;
  author: string;
  coverImage: string;
  publishedAt: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'hutao-flame-spirit-doujin',
    title: '《燃魂之蝶》—— 胡桃角色同人插画本精选',
    excerpt: '以往生堂第七十七代堂主胡桃为主题的精品同人插画集，收录了二十余位画师的精彩创作，从水墨风到现代插画，展现胡桃多样的魅力。',
    content: `<p>《燃魂之蝶》是一部以胡桃为中心角色的同人插画合集，由「蝶火社」策划出品。本作集结了二十余位活跃于同人圈的优秀画师，以各自独特的艺术风格诠释胡桃这一角色的多面魅力。</p>
    <h2>创作背景</h2>
    <p>胡桃作为往生堂第七十七代堂主，以其活泼开朗却又深谙生死哲理的独特人设，成为原神中最受欢迎的角色之一。她的「蝶引来生」秘法、标志性的梅花瞳以及那顶乾坤泰卦帽，都为同人创作提供了丰富的灵感素材。</p>
    <p>《燃魂之蝶》的创作团队耗时六个月，从草图构思到最终成稿，每一位画师都倾注了大量心血。作品风格涵盖水墨写意、赛璐珞风格、厚涂技法等多种类型，力求为读者呈现一场视觉盛宴。</p>
    <h2>内容亮点</h2>
    <p>全书共分为四个章节：「往生之仪」—— 以庄重典雅风格描绘胡桃主持往生仪式的场景；「蝶舞之时」—— 捕捉胡桃在璃月街头巷尾的日常瞬间；「冥界之约」—— 充满想象力的冥界冒险题材创作；「诗与烟火」—— 以诗意笔触展现胡桃与伙伴们的羁绊。</p>
    <p>每一幅插画都配有画师的创作心得，让读者不仅欣赏作品，更能了解背后的创作故事与灵感来源。</p>
    <h2>读者评价</h2>
    <p>「这是一本让我重新认识胡桃的书。每一位画师都用自己独特的方式诠释了她，从可爱到深沉，从活泼到哲思，胡桃的每一面都被完美呈现。」—— 资深同人收藏者 林月</p>
    <p>「水墨风的那几幅简直惊艳！用中国传统技法表现原神角色，这种文化碰撞太美了。」—— 同人画师 星河</p>`,
    category: 'character-doujin',
    character: '胡桃',
    author: '蝶火社',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Hu%20Tao%20doujinshi%20illustration%20book%20cover%20with%20butterfly%20motif%2C%20traditional%20Chinese%20watercolor%20style%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20elegant%20Chinese%20calligraphy%20title%2C%20artistic%20composition%2C%20cream%20paper%20texture%20background%2C%20golden%20decorative%20border%2C%20premium%20art%20book%20quality%2C%20soft%20dramatic%20lighting&width=800&height=1100&seq=article-hutao&orientation=portrait',
    publishedAt: '2026-07-15',
    readTime: '8分钟',
    tags: ['胡桃', '角色同人', '插画集', '水墨风'],
    featured: true,
  },
  {
    slug: 'zhongli-contract-of-stone-doujin',
    title: '《磐岩之契》—— 钟离同人漫画合集',
    excerpt: '以岩王帝君钟离为主角的同人漫画合集，讲述璃月六千年的历史风云与钟离在现世中的优雅日常。',
    content: `<p>《磐岩之契》是一部以钟离为核心的同人漫画合集，由「璃月书坊」精心策划。本作通过漫画形式，深入探讨了钟离作为岩王帝君的过去与作为凡人钟离的现在。</p>
    <h2>故事概要</h2>
    <p>漫画分为「过去篇」与「现世篇」两大篇章。「过去篇」以大气磅礴的笔触描绘魔神战争时期，岩王帝君率领众仙守护璃月的壮阔史诗；「现世篇」则以轻松优雅的笔调记录钟离在璃月港的日常生活——品茶、听戏、鉴宝，以及与旅行者之间温暖有趣的互动。</p>
    <h2>艺术风格</h2>
    <p>画师团队采用了独特的「双线并行」艺术手法——「过去篇」使用厚重的史诗风格，以大量留白与水墨渲染营造古朴庄严的氛围；「现世篇」则采用清新雅致的线条风格，色彩柔和温暖，与钟离优雅从容的气质相得益彰。</p>
    <p>全书共收录十二个短篇漫画故事，总页数超过两百页，是一部不可多得的同人漫画精品。</p>`,
    category: 'doujin-comic',
    character: '钟离',
    author: '璃月书坊',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Zhongli%20doujinshi%20manga%20cover%20with%20geo%20element%20motif%2C%20elegant%20traditional%20Chinese%20ink%20wash%20painting%20style%2C%20warm%20amber%20and%20gold%20color%20palette%2C%20mountain%20silhouette%20background%2C%20artistic%20composition%2C%20cream%20paper%20texture%2C%20premium%20book%20design%2C%20soft%20dramatic%20lighting&width=800&height=1100&seq=article-zhongli&orientation=portrait',
    publishedAt: '2026-07-10',
    readTime: '12分钟',
    tags: ['钟离', '同人漫画', '璃月', '史诗'],
    featured: true,
  },
  {
    slug: 'raiden-eternity-illustration',
    title: '《永恒之雷》—— 雷电将军主题插画集',
    excerpt: '聚焦稻妻雷电将军的绝美同人插画集，以雷光与永恒为主题，收录了众多画师对雷电将军的精彩演绎。',
    content: `<p>《永恒之雷》是一部以雷电将军（巴尔/巴尔泽布）为主题的同人插画集，由稻妻同人社团「鸣神会」倾力打造。本作以「永恒」为核心概念，通过画师们的笔触探索雷电将军这一复杂角色的多重维度。</p>
    <h2>主题阐释</h2>
    <p>雷电将军追求「永恒」，而这份执念背后是对失去的恐惧与对所爱之人的守护。画集分为「雷光」「静寂」「永恒」三个章节，分别从力量的威严、内心的孤寂以及最终的觉悟三个层面解读雷电将军。</p>
    <p>「雷光」章节以强烈的视觉冲击展现雷电将军「无想的一刀」的震撼威力；「静寂」章节捕捉雷电将军在一心净土中的沉思与孤独；「永恒」章节则描绘她与稻妻子民、与旅行者之间的温情互动。</p>`,
    category: 'illustration-book',
    character: '雷电将军',
    author: '鸣神会',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Raiden%20Shogun%20illustration%20art%20book%20cover%20with%20lightning%20motif%2C%20Japanese%20ink%20painting%20style%2C%20purple%20and%20gold%20color%20palette%2C%20elegant%20composition%2C%20cream%20paper%20texture%2C%20traditional%20Japanese%20aesthetic%2C%20premium%20art%20book%20quality&width=800&height=1100&seq=article-raiden&orientation=portrait',
    publishedAt: '2026-07-05',
    readTime: '10分钟',
    tags: ['雷电将军', '插画集', '稻妻', '永恒'],
    featured: true,
  },
  {
    slug: 'nahida-dream-garden-novel',
    title: '《梦园絮语》—— 纳西妲主题同人小说本',
    excerpt: '以须弥草神纳西妲为主角的同人小说合集，用细腻的文字编织关于智慧、成长与温柔的动人故事。',
    content: `<p>《梦园絮语》是一部以纳西妲为核心的短篇同人小说集，由「须弥学舍」文学社创作。全书收录八篇独立短篇小说，以温暖治愈的笔触书写纳西妲与须弥子民之间的故事。</p>
    <h2>故事主题</h2>
    <p>每一篇小说都围绕一个关键词展开：第一篇《花神诞日》讲述纳西妲第一次真正走出净善宫参加花神诞祭的经历；第二篇《沙漠之星》记录纳西妲前往阿如村探望沙漠子民的旅程；第三篇《梦境图书馆》描绘纳西妲在梦境中为须弥的孩子们建造一座知识的花园……</p>
    <p>这些故事既有温馨治愈的日常，也有触动心弦的成长，读者可以透过文字感受到纳西妲作为智慧之神那份纯真而深邃的温柔。</p>`,
    category: 'novel-book',
    character: '纳西妲',
    author: '须弥学舍',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Nahida%20fan%20novel%20book%20cover%20with%20dendro%20plant%20motif%2C%20soft%20watercolor%20illustration%20style%2C%20green%20and%20cream%20color%20palette%2C%20dreamy%20garden%20atmosphere%2C%20elegant%20typography%2C%20warm%20natural%20lighting%2C%20literary%20magazine%20quality&width=800&height=1100&seq=article-nahida&orientation=portrait',
    publishedAt: '2026-06-28',
    readTime: '15分钟',
    tags: ['纳西妲', '同人小说', '须弥', '治愈'],
    featured: true,
  },
  {
    slug: 'furina-opera-masquerade-doujin',
    title: '《歌剧假面》—— 芙宁娜同人漫画精选集',
    excerpt: '以枫丹水神芙宁娜为主角的同人漫画，以华丽歌剧风格呈现这位戏剧之神的台前幕后。',
    content: `<p>《歌剧假面》是一部以芙宁娜为主角的同人漫画精选集。本作以枫丹歌剧院为舞台，用华丽的画面与细腻的叙事，讲述芙宁娜在舞台上的光芒万丈与舞台下的孤独守望。</p>
    <h2>艺术风格</h2>
    <p>漫画采用独特的「歌剧幕间」结构，每一话之间以歌剧院幕布开合作为转场。画风融合了巴洛克艺术的华丽装饰风格与现代漫画的叙事节奏，营造出独属于枫丹的浪漫与戏剧感。</p>
    <p>全书共收录六个篇章，从芙宁娜的初次登台到最终的自我和解，一部关于「表演」与「真实」的深刻同人佳作。</p>`,
    category: 'doujin-comic',
    character: '芙宁娜',
    author: '枫丹剧团',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Furina%20doujinshi%20manga%20cover%20with%20opera%20stage%20motif%2C%20baroque%20art%20style%20influence%2C%20blue%20and%20gold%20color%20palette%2C%20dramatic%20theater%20lighting%2C%20elegant%20composition%2C%20cream%20paper%20texture%2C%20premium%20book%20design&width=800&height=1100&seq=article-furina&orientation=portrait',
    publishedAt: '2026-06-20',
    readTime: '11分钟',
    tags: ['芙宁娜', '同人漫画', '枫丹', '歌剧'],
    featured: false,
  },
  {
    slug: 'ganyu-qingxin-diary-illustration',
    title: '《清心日记》—— 甘雨角色同人插画特辑',
    excerpt: '以甘雨工作与生活的日常为灵感，温柔画风记录这位半仙秘书在璃月港的点滴时光。',
    content: `<p>《清心日记》是一部以甘雨为主角的同人插画特辑。作品以「日记」为线索，用柔和唯美的画面记录甘雨在璃月港工作与生活的每一个温暖瞬间。</p>
    <h2>创作理念</h2>
    <p>甘雨既是千年的半仙之兽，也是璃月七星最勤奋的秘书。画师们试图捕捉她身上这种「神性」与「人性」交织的独特魅力——在工作中一丝不苟的专注，在清心花田中独自休憩的恬静，与璃月港孩子们相处时温柔的微笑。</p>
    <p>全书以四季为章节划分，配合柔和的色调与精致的光影处理，营造出如诗如画的阅读体验。</p>`,
    category: 'illustration-book',
    character: '甘雨',
    author: '清心画社',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Ganyu%20illustration%20art%20book%20cover%20with%20qingxin%20flower%20motif%2C%20soft%20pastel%20watercolor%20style%2C%20blue%20and%20cream%20color%20palette%2C%20gentle%20natural%20atmosphere%2C%20elegant%20Chinese%20aesthetic%2C%20premium%20art%20book%20quality&width=800&height=1100&seq=article-ganyu&orientation=portrait',
    publishedAt: '2026-06-15',
    readTime: '7分钟',
    tags: ['甘雨', '插画集', '日记', '清新'],
    featured: false,
  },
  {
    slug: 'keqing-lightning-blade-doujin',
    title: '《霆霓快雨》—— 刻晴同人漫画特辑',
    excerpt: '以玉衡星刻晴为主角的同人漫画，描绘这位雷厉风行的少女在璃月改革之路上的奋斗与成长。',
    content: `<p>《霆霓快雨》是一部以刻晴为主角的同人漫画特辑。作为璃月七星中的改革派代表，刻晴的故事充满了理想与现实的碰撞，本作通过五个篇章深入刻画了她的成长轨迹。</p>
    <h2>故事架构</h2>
    <p>漫画从刻晴初入璃月七星开始讲起，到她推动璃月港现代化建设过程中遭遇的阻力，以及她如何在坚持理想的同时学会理解传统。故事中穿插了她与旅行者的相遇、与凝光的理念之争，以及她逐渐领悟「变革需要时间」这一道理的心路历程。</p>`,
    category: 'doujin-comic',
    character: '刻晴',
    author: '玉衡工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Keqing%20doujinshi%20manga%20cover%20with%20lightning%20sword%20motif%2C%20modern%20Chinese%20ink%20style%2C%20purple%20and%20cream%20color%20palette%2C%20dynamic%20composition%2C%20elegant%20typography%2C%20premium%20book%20design&width=800&height=1100&seq=article-keqing&orientation=portrait',
    publishedAt: '2026-06-08',
    readTime: '9分钟',
    tags: ['刻晴', '同人漫画', '璃月', '改革'],
    featured: false,
  },
  {
    slug: 'ayaka-snow-heron-cp-doujin',
    title: '《雪鹤之舞》—— 神里绫华CP向同人本',
    excerpt: '细腻描绘神里绫华与旅行者之间含蓄而真挚的情感，一本温暖人心的CP向同人作品合集。',
    content: `<p>《雪鹤之舞》是一部以神里绫华为核心的CP向同人作品合集。本作以稻妻的四季流转为时间线，细腻地描绘了白鹭公主与旅行者从初遇到相知的每一个珍贵时刻。</p>
    <h2>情感刻画</h2>
    <p>与其他同人作品不同，《雪鹤之舞》着重于「含蓄之美」——没有轰轰烈烈的告白，只有樱花树下的一次对视、祭典中悄然靠近的距离、雪夜温泉旁分享的一碗茶泡饭。这些细腻微小的瞬间，构成了最动人的情感叙事。</p>
    <p>全书以联动漫画与插画的形式呈现，文字部分采用和歌体的短句点缀其间，整体风格唯美而克制，正如神里绫华本人一样优雅含蓄。</p>`,
    category: 'cp-doujin',
    character: '神里绫华',
    author: '雪鹤社',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Kamisato%20Ayaka%20romantic%20doujinshi%20cover%20with%20cherry%20blossom%20and%20snow%20motif%2C%20soft%20watercolor%20style%2C%20pink%20and%20cream%20color%20palette%2C%20elegant%20Japanese%20aesthetic%2C%20warm%20emotional%20atmosphere%2C%20premium%20book%20design&width=800&height=1100&seq=article-ayaka&orientation=portrait',
    publishedAt: '2026-05-30',
    readTime: '10分钟',
    tags: ['神里绫华', 'CP向', '稻妻', '温情'],
    featured: true,
  },
  {
    slug: 'klee-spark-knight-illustration',
    title: '《火花骑士》—— 可莉主题同人绘本',
    excerpt: '献给全提瓦特最可爱的小太阳可莉！一本充满童趣与想象力的同人绘本合集。',
    content: `<p>《火花骑士》是一部以可莉为主角的同人绘本合集。这是送给全提瓦特最可爱的小太阳的一份礼物——通过温暖明亮的画面与轻松有趣的小故事，展现可莉纯真无邪的冒险日常。</p>
    <h2>绘本特色</h2>
    <p>全书采用绘本式大开本设计，画风活泼可爱，色彩明快温暖。每一页都充满了童趣——可莉在星落湖炸鱼、在风龙废墟探险、与阿贝多哥哥一起做实验、偷偷给琴团长准备「惊喜」……每一个故事都让人会心一笑。</p>`,
    category: 'illustration-book',
    character: '可莉',
    author: '火花俱乐部',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Klee%20illustration%20children%20book%20cover%20with%20spark%20and%20bomb%20motif%2C%20cute%20colorful%20anime%20style%2C%20red%20and%20cream%20color%20palette%2C%20playful%20atmosphere%2C%20picture%20book%20design%2C%20warm%20lighting&width=800&height=1100&seq=article-klee&orientation=portrait',
    publishedAt: '2026-05-22',
    readTime: '6分钟',
    tags: ['可莉', '绘本', '蒙德', '可爱'],
    featured: false,
  },
  {
    slug: 'venti-wind-poem-doujin',
    title: '《风与诗篇》—— 温迪同人创作合集',
    excerpt: '以蒙德风神巴巴托斯（温迪）为主题的多元同人合集，融合诗歌、插画与短篇漫画于一册。',
    content: `<p>《风与诗篇》是一部以温迪为核心的多元同人创作合集。作为蒙德的风神巴巴托斯，温迪的形象充满了诗意与自由精神，本作以诗歌、插画、短篇漫画三种形式交相辉映，全方位展现这位吟游诗人的魅力。</p>
    <h2>多元形式</h2>
    <p>「诗篇」部分收录了十首以温迪视角创作的抒情诗，既有对蒙德自由的礼赞，也有对故友的追忆；「画卷」部分以唯美的插画捕捉温迪在风中弹奏竖琴的每一个动人瞬间；「故事」部分则通过短篇漫画讲述温迪在蒙德城中的趣事与冒险。</p>`,
    category: 'character-doujin',
    character: '温迪',
    author: '蒲公英诗社',
    coverImage: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20Venti%20doujinshi%20cover%20with%20wind%20and%20lyre%20motif%2C%20soft%20watercolor%20anime%20style%2C%20green%20and%20cream%20color%20palette%2C%20poetic%20atmosphere%2C%20elegant%20typography%2C%20premium%20book%20design&width=800&height=1100&seq=article-venti&orientation=portrait',
    publishedAt: '2026-05-15',
    readTime: '10分钟',
    tags: ['温迪', '角色同人', '诗歌', '蒙德'],
    featured: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getLatestArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, count);
};

export const getRelatedArticles = (currentSlug: string, category: string, count: number = 3): Article[] => {
  return articles.filter((a) => a.slug !== currentSlug && a.category === category).slice(0, count);
};